import { useTheme } from "../context/ThemeContext";
import { RadiusBorderLeft, RadiusBorderRight } from "./SVGIcons"

export const RadiusBorder = () => {
    const { theme } = useTheme();
    return (
        <div className="absolute top-0 left-0 w-full h-full flex opacity-[6%] dark:opacity-20 pointer-events-none" style={{
            mask: 'linear-gradient(to bottom, rgba(0,0,0,1) 0%, rgba(0,0,0,0.8) 50%, rgba(0,0,0,0) 100%)',
            WebkitMask: 'linear-gradient(to bottom, rgba(0,0,0,1) 0%, rgba(0,0,0,0.8) 50%, rgba(0,0,0,0) 100%)'
        }}>
            <RadiusBorderLeft fillColor={theme === 'dark' ? '#fff' : '#000'} />
            <div className="flex-1 h-[1px] w-full bg-black dark:bg-white" />
            <RadiusBorderRight fillColor={theme === 'dark' ? '#fff' : '#000'} />
        </div>
    )
}